export default __webpack_public_path__ + "static/better-7d5451d27edca26f44cbc41c76c85787.svg";